<template>
<div class="contents">
  <admin-vehicles adminType="staff" />
</div>
</template>

<script>
import AdminVehicles from './../Admin/AdminVehicles.vue'

export default {
  name: 'staff-vehicles',
  components: {
    AdminVehicles
  }
}
</script>
